import { batch } from 'react-redux';

import { ISpecOffer } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers';

import { setIsPopupOpened, setSelectedOfferId } from '~/src/features/specialOffersContainer/store/actions';
import { loadOffers } from '~/src/features/specialOffersContainer/store/actions/thunk/index';
import { TAppThunkDispatch } from '~/src/store';

export const loadOffer = (requestId: ISpecOffer['requestId']) => async(dispatch: TAppThunkDispatch): Promise<void> => {
    await dispatch(loadOffers());

    batch(() => {
        dispatch(setSelectedOfferId(requestId));
        dispatch(setIsPopupOpened(true));
    });
};
